import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { getLabel, handleTabKey } from '../../utils';

import SearchBarHolder from './SearchBarStyles';

const SearchBar = props => {
	const [searchTerm, setSearchTerm] = useState("");
	const [delayAnim, setDelayAnim] = useState();
	const inputRef = useRef(null);
	const modalRef = useRef(null);

	useEffect(() => {
		if (props.active) {
			document.addEventListener("keydown", (e) => props.handleEscape(e, props.searchClickHandler));
		} else {
			document.removeEventListener("keydown", (e) => props.handleEscape(e, props.searchClickHandler));
		}
		setTimeout(()=>{
			if (props.active && inputRef && inputRef.current) {
				inputRef.current.focus();
			}
		},500);
	}, [props.active]);

	useEffect(() => {
		if( props.active && modalRef.current){
			const keyListenersMap = props.active ? new Map([[27, props.searchClickHandler], [9, (e) => handleTabKey(e, modalRef)]]) : null;
			function keyListener(e) {
				const listener = keyListenersMap.get(e.keyCode);
				return listener && listener(e);
			}
			document.addEventListener("keydown", keyListener);
			setDelayAnim(false);

			return () => document.removeEventListener("keydown", keyListener);
		} else {
			setTimeout(()=>{
				setDelayAnim(true);
			},500);
		}

	}, [props.active]);

	const handleKeyPress = (e) => {
		if (e.key === 'Enter' || e.keyCode === 13) {
			searchClickHandler(e);
		}
	}

	const searchTermChange = (e) => {
		setSearchTerm(e.target.value.replaceAll(":", "%5C%3A").replaceAll("{", "").replaceAll("}", "").replaceAll("[", "").replaceAll("]", ""));
	}

	const searchClickHandler = (e) => {
		e.preventDefault();
		const searchUrl = props.searchpages[props.current_lang];
		window.location.href = `${searchUrl}?key=${searchTerm}`;
	}

	return (
		<SearchBarHolder>
			<div className={`search-bar ${props.active ? "expandDownS-appear" : "expandDownS-collapse"} ${delayAnim ? "hidden" : ""}`} aria-hidden={props.active ? false : true} tabIndex={props.active ? 0 : -1}>
				<div className="container" ref={modalRef}>
					<input
						aria-label={getLabel("SEARCH")}
						name={getLabel("SEARCH")}
						placeholder={getLabel("SEARCHPLACEHOLDER")}
						onChange={searchTermChange}
						onKeyPress={(e)=>handleKeyPress(e)}
						ref={ inputRef }
						type="text"
					></input>
					<button onClick={(e) => searchClickHandler(e)}>{getLabel("SEARCH")}</button>
				</div>
			</div>
		</SearchBarHolder>
	)
}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
	searchpages: store.search.pages
});
  
export default connect(mapStateToProps,null)(SearchBar);
